export default class Scout {
  chooseWithTotalSentMail(radio_button){
    // Uncheck all checkboxes
    $('input#chk_all:checkbox, .scout_member input:checkbox').prop('checked', false)

    // Check those who match the value in the radio button
    // and the total of scout mails sent to the user
    $('.scout_member').each((_i, elm) => {
      if (elm.getElementsByTagName('input').length > 0) {
        const count = elm.getElementsByClassName('total-scoutmail')[0].textContent.replace( /^\D+/g, '')
        if(count <= radio_button){
          elm.getElementsByTagName('input')[0].checked = true
        }
      }
    })
  }

  uncheckRecent() {
    var past_date = new Date()

    past_date.setDate(past_date.getDate() - 60)

    $('.scout_latest_date').each(function (_idx, elm) {
      var latest_scout_date = Date.parse(elm.innerHTML)

      if (latest_scout_date > past_date) {
        var chkboxes = $('#member_id_' + elm.getAttribute('member-id'))

        chkboxes.each(function (_idx2, chkbox) {
          chkbox.checked = false;
        })
      }
    })
  }

  checkAtLeastOneSelected(form) {
    let inputs = form.getElementsByTagName('input')
    let memberIds = ''

    for (let i = 0; i < inputs.length; i++) {
      let input = inputs[i]

      if (input.type === 'checkbox') {
        if (input.checked && input.id !== 'chk_all') {
          memberIds = memberIds + input.value + ','
        }
      }
    }

    if (memberIds) {
      $('#multiple-scout-member').val(memberIds)
    } else {
      alert(gon.alert_text)
      return false
    }
  }

  sendMailTop() {
    $('form#js-sendmail').submit()
  }

  onToggleSaveAsTemplate(target) {
    let isChecked = $(target).is(':checked')
    if (isChecked) {
      $('input#template_name').removeAttr('disabled')
      $('input#template_name').removeClass('d-none')
    } else {
      $('input#template_name').prop('disabled', true)
      $('input#template_name').val('')
      $('input#template_name').addClass('d-none')
      $('div.js-save-template-error-area').remove()
    }
  }

  onChangePerPage(target) {
    let value = $(target).val()
    let href  = window.location.href
    let url   = new URL(href)
    url.searchParams.set('page', 1)
    url.searchParams.set('per_page', value)
    url.searchParams.set('last_button', false)
    window.location.replace(url.href)
  }
}
